export const ROUTES = {
  LOGIN: '/login',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  ROOT: '/',
  DASHBOARD: '/dashboard',
  ANALYTICS_CONTENT: '/analytics/content-performance',

  ARTICLES: '/articles',
  ARTICLE_NEW: '/articles/new',
  ARTICLE_EDIT: '/articles/:id',

  SSS: '/sss',
  SSS_NEW: '/sss/new',
  SSS_EDIT: '/sss/:id',
  SSS_ANALYTICS: '/sss/analytics',

  CAMPAIGNS: '/campaigns',
  CAMPAIGN_NEW: '/campaigns/new',
  CAMPAIGN_EDIT: '/campaigns/:id',

  WORKFLOW_QUEUE: '/workflow/queue',

  WEB_REDIRECTS: '/web/redirects',
  WEB_OG_PREVIEW: '/web/og-preview',
  WEB_SEO: '/web/seo',

  MENUS: '/content/menus',
  MENU_EDIT: '/content/menus/:id',

  SLIDERS: '/content/sliders',
  BANNERS: '/content/banners',
  POPUPS: '/content/popups',

  FORMS: '/content/forms',
  FORM_EDIT: '/content/forms/:id',
  FORM_SUBMISSIONS: '/content/forms/:id/submissions',

  COMPONENTS: '/content/components',
  COMPONENT_EDIT: '/content/components/:id',

  BRANCHES: '/content/branches',
  BRANCH_NEW: '/content/branches/new',
  BRANCH_EDIT: '/content/branches/:id',

  PAGES: '/pages',
  PAGE_NEW: '/pages/new',
  PAGE_EDIT: '/pages/:id',
  PAGE_PUBLIC: '/p/:slug',

  ADMIN_USERS: '/users/admin',
  ROLES: '/users/roles',
  KVKK_DELETIONS: '/users/kvkk-deletions',
  KVKK_MY_REQUEST: '/users/my-kvkk-request',

  AUDIT_LOG: '/audit',
  AUDIT_LOG_DETAIL: '/audit/:id',

  SETTINGS_KEY: '/settings/:key',

  MEDIA: '/media',
  MEDIA_FOLDER: '/media/folder/:folderId',

  TRANSLATIONS: '/localization/translations',
  LANGUAGES: '/localization/languages',

  IP_ALLOWLIST: '/security/ip-allowlist',

  CATEGORIES: '/taxonomy/categories',
  TAGS: '/taxonomy/tags',
  AUTHORS: '/taxonomy/authors',

  PROFILE: '/profile',
  SETTINGS: '/settings',
  SMTP_SETTINGS: '/settings/smtp',
  LDAP_SETTINGS: '/settings/ldap',
  PROJECTS: '/settings/projects',
  API_KEYS: '/security/api-keys',
  FORBIDDEN: '/403',
  NOT_FOUND: '/404',
} as const;

export type RoutePath = (typeof ROUTES)[keyof typeof ROUTES];
